import type { Offer } from '@/utils/offers'
export default function NatTermsSummary({ offer }: { offer: Offer }) {
	if (!offer.nat_terms) return null
	return <span className="block break-words text-xs text-muted-foreground">{offer.nat_terms.token_amount} NAT · ≈ {offer.nat_terms.sats_per_nat} sats/NAT · Exact lot</span>
}
